// import React, { useState, useEffect } from "react";
// import VideoCard from "./VideoCard";
// import VideoPlayerDialog from "./VideoPlayerDialog";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   Button,
//   Box,
//   CircularProgress,
//   Alert,
// } from "@mui/material";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../../../Firebase/Firebase";

// const YouTubeContent = () => {
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [youtubeVideos, setYoutubeVideos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Direct Firebase data fetch
//   useEffect(() => {
//     const fetchVideosFromDB = async () => {
//       try {
//         setLoading(true);
//         const querySnapshot = await getDocs(collection(db, "linkCollections"));
//         const videosData = [];
//         let idCounter = 1;

//         querySnapshot.forEach((doc) => {
//           const collectionData = doc.data();
//           const collectionVideos = collectionData.videos || [];

//           collectionVideos.forEach((video) => {
//             videosData.push({
//               id: idCounter++,
//               title: video.title || "",
//               description: video.description || "",
//               videoId: video.videoId || "",
//               views:
//                 typeof video.views === "number"
//                   ? video.views.toString()
//                   : video.views || "0",
//               duration: video.duration || "0:00",
//               uploadDate: video.uploadDate || "",
//               thumbnail:
//                 video.thumbnail ||
//                 `https://i.ytimg.com/vi/${video.videoId}/hqdefault.jpg`,
//               channelTitle: video.channelTitle || "",
//             });
//           });
//         });

//         setYoutubeVideos(videosData);
//         setError(null);
//       } catch (err) {
//         console.error("Error fetching videos from Firebase: ", err);
//         setError("Failed to load videos from database");
//         setYoutubeVideos([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchVideosFromDB();
//   }, []);

//   const handleVideoPlay = (video) => setSelectedVideo(video);
//   const handleCloseDialog = () => setSelectedVideo(null);

//   if (loading) {
//     return (
//       <Box sx={{ textAlign: "center", py: 8 }}>
//         <CircularProgress size={40} />
//         <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
//           Loading videos...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box sx={{ textAlign: "center", py: 8 }}>
//         <Alert severity="error" sx={{ maxWidth: 500, mx: "auto" }}>
//           {error}
//         </Alert>
//       </Box>
//     );
//   }

//   return (
//     <>
//       <Card
//         variant="outlined"
//         sx={{
//           p: { xs: 2, sm: 3, md: 4 },
//           backgroundColor: "#ffffff",
//           borderColor: "rgba(0, 0, 0, 0.12)",
//           boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h3"
//             component="h2"
//             gutterBottom
//             textAlign="center"
//             sx={{
//               fontWeight: "bold",
//               color: "text.primary",
//               fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
//               mb: 2,
//             }}
//           >
//             Our YouTube Content
//           </Typography>
//           <Typography
//             variant="h6"
//             textAlign="center"
//             sx={{
//               mb: 4,
//               color: "text.secondary",
//               fontSize: { xs: "1rem", sm: "1.25rem" },
//             }}
//           >
//             Check out our latest videos on social media strategies and digital
//             marketing.{" "}
//             {youtubeVideos.length > 0 && `(${youtubeVideos.length} videos)`}
//           </Typography>

//           {youtubeVideos.length === 0 ? (
//             <Box sx={{ textAlign: "center", py: 4 }}>
//               <Typography variant="h6" color="text.secondary">
//                 No videos available yet. Please add some videos from the admin
//                 panel.
//               </Typography>
//             </Box>
//           ) : (
//             <>
//               {/* Grid with 4 cards per row on large screens */}
//               <Grid container spacing={3}>
//                 {youtubeVideos.map((video) => (
//                   <Grid
//                     item
//                     xs={12}
//                     sm={6}
//                     md={3} // 4 cards per row on medium and large screens
//                     key={video.id}
//                     sx={{
//                       display: "flex",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: "100%",
//                         maxWidth: "300px", // Fixed width for all cards
//                       }}
//                     >
//                       <VideoCard
//                         video={video}
//                         onPlay={handleVideoPlay}
//                         sx={{
//                           height: "400px", // Fixed height
//                           width: "100%",
//                         }}
//                       />
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>

//               <Box sx={{ textAlign: "center", mt: 5 }}>
//                 <Button
//                   variant="contained"
//                   size="large"
//                   sx={{
//                     px: 4,
//                     borderRadius: 2,
//                   }}
//                 >
//                   Load More Videos
//                 </Button>
//               </Box>
//             </>
//           )}
//         </CardContent>
//       </Card>

//       <VideoPlayerDialog
//         open={!!selectedVideo}
//         onClose={handleCloseDialog}
//         video={selectedVideo}
//       />
//     </>
//   );
// };

// export default YouTubeContent;

import React, { useState, useEffect } from "react";
import VideoCard from "./VideoCard";
import VideoPlayerDialog from "./VideoPlayerDialog";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../Firebase/Firebase";

const YouTubeContent = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [youtubeVideos, setYoutubeVideos] = useState([]);
  const [displayedVideos, setDisplayedVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const videosPerPage = 8; // Load 8 more videos each time

  // Direct Firebase data fetch
  useEffect(() => {
    const fetchVideosFromDB = async () => {
      try {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, "linkCollections"));
        const videosData = [];
        let idCounter = 1;

        querySnapshot.forEach((doc) => {
          const collectionData = doc.data();
          const collectionVideos = collectionData.videos || [];

          collectionVideos.forEach((video) => {
            videosData.push({
              id: idCounter++,
              title: video.title || "",
              description: video.description || "",
              videoId: video.videoId || "",
              views:
                typeof video.views === "number"
                  ? video.views.toString()
                  : video.views || "0",
              duration: video.duration || "0:00",
              uploadDate: video.uploadDate || "",
              thumbnail:
                video.thumbnail ||
                `https://i.ytimg.com/vi/${video.videoId}/hqdefault.jpg`,
              channelTitle: video.channelTitle || "",
            });
          });
        });

        setYoutubeVideos(videosData);
        setError(null);
      } catch (err) {
        console.error("Error fetching videos from Firebase: ", err);
        setError("Failed to load videos from database");
        setYoutubeVideos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVideosFromDB();
  }, []);

  // Update displayed videos when youtubeVideos or currentPage changes
  useEffect(() => {
    if (youtubeVideos.length > 0) {
      const endIndex = currentPage * videosPerPage;
      const videosToShow = youtubeVideos.slice(0, endIndex);
      setDisplayedVideos(videosToShow);
    }
  }, [youtubeVideos, currentPage]);

  const handleLoadMore = () => {
    setLoadingMore(true);

    // Simulate loading delay for better UX
    setTimeout(() => {
      setCurrentPage((prev) => prev + 1);
      setLoadingMore(false);
    }, 500);
  };

  const handleVideoPlay = (video) => setSelectedVideo(video);
  const handleCloseDialog = () => setSelectedVideo(null);

  // Calculate if all videos are loaded
  const allVideosLoaded = displayedVideos.length >= youtubeVideos.length;
  const remainingVideos = youtubeVideos.length - displayedVideos.length;

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", py: 8 }}>
        <CircularProgress size={40} />
        <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
          Loading videos...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Alert severity="error" sx={{ maxWidth: 500, mx: "auto" }}>
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          p: { xs: 2, sm: 3, md: 10 },
          backgroundColor: "#ffffff",
          borderColor: "rgba(0, 0, 0, 0.12)",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <Typography
            variant="h3"
            component="h2"
            gutterBottom
            textAlign="center"
            sx={{
              fontWeight: "bold",
              color: "text.primary",
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              mb: 2,
            }}
          >
            Our YouTube Content
          </Typography>
          <Typography
            variant="h6"
            textAlign="center"
            sx={{
              mb: 4,
              color: "text.secondary",
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            Check out our latest videos on social media strategies and digital
            marketing.{" "}
            {youtubeVideos.length > 0 && (
              <Box
                component="span"
                sx={{ color: "primary.main", fontWeight: 600 }}
              >
                ({displayedVideos.length} of {youtubeVideos.length} videos)
              </Box>
            )}
          </Typography>

          {youtubeVideos.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography variant="h6" color="text.secondary">
                No videos available yet. Please add some videos from the admin
                panel.
              </Typography>
            </Box>
          ) : (
            <>
              {/* Grid with 4 cards per row on large screens */}
              <Grid container spacing={3}>
                {displayedVideos.map((video) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    key={video.id}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "300px",
                      }}
                    >
                      <VideoCard
                        video={video}
                        onPlay={handleVideoPlay}
                        sx={{
                          height: "400px",
                          width: "100%",
                        }}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>

              {/* Load More Button Section */}
              {!allVideosLoaded && (
                <Box sx={{ textAlign: "center", mt: 5 }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleLoadMore}
                    disabled={loadingMore}
                    sx={{
                      px: 4,
                      borderRadius: 2,
                      minWidth: 160,
                      position: "relative",
                    }}
                  >
                    {loadingMore ? (
                      <>
                        <CircularProgress
                          size={24}
                          sx={{
                            color: "white",
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        />
                        <Box sx={{ opacity: 0 }}>Loading...</Box>
                      </>
                    ) : (
                      `Load More (${remainingVideos})`
                    )}
                  </Button>

                  {!loadingMore && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      Showing {displayedVideos.length} of {youtubeVideos.length}{" "}
                      videos
                    </Typography>
                  )}
                </Box>
              )}

              {/* All videos loaded message */}
              {allVideosLoaded && youtubeVideos.length > 0 && (
                <Box sx={{ textAlign: "center", mt: 3 }}>
                  <Typography
                    variant="body1"
                    color="success.main"
                    sx={{
                      fontWeight: 600,
                      fontStyle: "italic",
                    }}
                  >
                    🎉 All {youtubeVideos.length} videos loaded!
                  </Typography>
                </Box>
              )}
            </>
          )}
        </CardContent>
      </Card>

      <VideoPlayerDialog
        open={!!selectedVideo}
        onClose={handleCloseDialog}
        video={selectedVideo}
      />
    </>
  );
};

export default YouTubeContent;
